/* eslint-disable no-undef */

const getDistance = (start, end) => {
  // noinspection JSUnresolvedFunction
  const service = new google.maps.DistanceMatrixService();

  return new Promise((resolve, reject) => {
    // noinspection JSUnresolvedFunction
    service.getDistanceMatrix(
      {
        origins: [start],
        destinations: [end],
        travelMode: "DRIVING",
      },
      (response, status) => {
        if (status === "OK") {
          resolve({ distance: response.rows[0].elements[0].distance.value });
        } else {
          reject({ distance: 0 });
        }
      }
    );
  });
};

const getAllDistance = (locations) => {
  const promisedDistances = [];

  for (let i = 0; i < locations.length - 1; i++) {
    promisedDistances.push(getDistance(locations[i], locations[i + 1]));
  }

  return Promise.all(promisedDistances);
};

export default async (locations) => {
  const initialValue = 0;
  const result = await getAllDistance(locations);

  return result
    .map((record) => record.distance)
    .reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
};
